import { Skeleton } from '@/_components';
import { LayoutBody } from '@/_pages/login/components';

export default function Loading() {
  return (
    <LayoutBody>
      <section className="mt-4 flex flex-col items-center gap-4">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="mt-1 h-8 w-48" />
      </section>
      <section className="mt-6 flex flex-col gap-4">
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="mt-px h-9.5 w-full" />
        <Skeleton className="mx-auto h-4 w-52" />
      </section>
    </LayoutBody>
  );
}
